import {
  FaFacebookF,
  FaWhatsapp,
  FaInstagram,
  FaTripadvisor,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import { useState } from "react";
import { Modal } from "../pop-up/pop-up";

export const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="wrapper">
      <div className="py-[80px] md:border-t md:mt-[100px]">
        <div className="max-w-[1210px] w-[calc(100%_-_60px)] mx-auto md:flex flex-row space-y-[20px] md:space-y-[0px]">
          <div className="basis-1/3 h-[200px]">
            <h5 className="mb-[30px] text-[18px]">Follow Us</h5>
            <p className="text-gray-text text-[15px] mb-[27px]">
              Keep up to the date with Country Yard
            </p>

            <div className="flex space-x-[10px]">
              <a
                href="https://www.facebook.com/profile.php?id=100063528068317"
                className="rounded-full w-[50px] h-[50px]  bg-golden"
              >
                <div className="rounded-full w-[50px] h-[50px]  bg-golden flex justify-center items-center">
                  <FaFacebookF className="text-white text-[18px]" />
                </div>
              </a>
              <a href="https://api.whatsapp.com/send?phone=%2B9779819730006&data=ARAYf1MQfEf5qW01Qzyojp3vxh_ftlOpLrtcXv7xcesUVcYzkALYvWLaVQyGF-QIs_t30sfoaOmAmby7nO2pgH6ZL3zd0oGghbRqtFda99EiSQSX0OgFqnsa11w2nYV-rrUIIxencBfb_C4LF-k7sNHLSQ&source=FB_Page&app=facebook&entry_point=page_cta&fbclid=IwAR1q0t3s-HGl1GoCGeNsPAOzWWIbgpfU_3hHDd_Qc5o7aK3AFwVK-4bXJDA">
                <div className="rounded-full w-[50px] h-[50px]  bg-golden flex justify-center items-center">
                  <FaWhatsapp className="text-white text-[20px]" />
                </div>
              </a>
              <a href="https://www.instagram.com/hotelthecountry/">
                <div className="rounded-full w-[50px] h-[50px]  bg-golden flex justify-center items-center">
                  <FaInstagram className="text-white text-[20px]" />
                </div>
              </a>
              <a href="https://maps.app.goo.gl/7dMkhzgd52KHvuNz7">
                <div className="rounded-full w-[50px] h-[50px]  bg-golden flex justify-center items-center">
                  <FaMapMarkerAlt className="text-white text-[18px]" />
                </div>
              </a>
              <a href="https://www.tripadvisor.com/Hotel_Review-g293891-d17386836-Reviews-The_Country_Yard-Pokhara_Gandaki_Zone_Western_Region.html">
                <div className="rounded-full w-[50px] h-[50px]  bg-golden flex justify-center items-center">
                  <FaTripadvisor className="text-white text-[20px]" />
                </div>
              </a>
            </div>
          </div>
          <div className="basis-1/3 h-[200px]">
            <h5 className="mb-[30px] text-[18px]">Contact</h5>
            <div className="flex space-x-[2px] items-center mb-[10px]">
              <div className="flex items-center justify-center w-8 h-8 mr-2 ">
                <FaPhone className=" text-golden text-[20px]"></FaPhone>
              </div>
              <p className="text-gray-text text-[15px]">
                +977-981973006, +977-061-457807
              </p>
            </div>
            <div className="flex space-x-[2px] items-center mb-[10px]">
              <div className="flex items-center justify-center w-8 h-8 mr-2 ">
                <FaMapMarkerAlt className=" text-golden text-[20px] "></FaMapMarkerAlt>
              </div>
              <p className="text-gray-text text-[15px]">
                28th Street, Lakeside, Pokhara, Nepal
              </p>
            </div>
            <div className="flex space-x-[2px] items-center mb-[10px]">
              <div className="flex items-center justify-center w-8 h-8 mr-2 ">
                <FaEnvelope className=" text-golden text-[20px]"></FaEnvelope>
              </div>
              <p className="text-gray-text text-[15px]">
                thecountryyard.70@gmail.com
              </p>
            </div>
          </div>
          <div className="basis-1/3 h-[200px]">
            <h5 className="mb-[30px] text-[18px]">Newsletter</h5>
            <p className="text-gray-text text-[15px] mb-[27px]">
              Sign up to our newsletter for exclusive offers.
            </p>
            {/* change it to form when implemented */}
            <div className="flex space-x-2 items-center">
              <input
                type="email"
                className="border-2 border-golden py-[17px] px-[15px] w-[calc(65%)] h-[57px]"
              />
              <button
                id="booknow-btn"
                className="bg-golden w-[calc(35%)] h-[57px] text-white font-bold mx-auto"
                onClick={() => {
                  setShowModal(!showModal);
                  //   const btn = document.getElementById("myaccount-btn");
                  //   btn.classList.toggle("open");
                }}
              >
                <p className="">Subscribe</p>
                {showModal && (
                  <Modal
                    showModal={showModal}
                    setShowModal={() => setShowModal(!showModal)}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="h-[150px] w-full bg-golden flex justify-center items-center">
        <p className="text-white text-center max-w-[calc(100%_-_20px)]">
          © 2023 Hotel The Country Yard. All Rights Reserved
        </p>
      </div>
    </div>
  );
};
